// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { text } from '../../tokens/themeColors/text';
export var avatarColors = function(mode) {
    var bg = background(mode);
    var bd = border(mode);
    var tx = text(mode);
    return {
        active: {
            background: bg.level300,
            border: bd.heaviest,
            text: tx.primary
        },
        default: {
            background: bg.level200,
            border: bd.default,
            text: tx.primary
        },
        disabled: {
            background: bg.state.disabled2,
            border: bd.soft,
            text: tx.disabled2
        },
        hover: {
            background: bg.level200,
            border: bd.heavy,
            text: tx.primary
        }
    };
};

//# sourceMappingURL=avatarColors.js.map